const KEY = "admin_token";

export const getAdminToken = () => sessionStorage.getItem(KEY);

export const setAdminToken = (token) => sessionStorage.setItem(KEY, token);

export const clearAdminToken = () => sessionStorage.removeItem(KEY);

export const isAdminMode = () => Boolean(sessionStorage.getItem(KEY));
